module.exports = __webpack_public_path__ + "static/media/hw-red-circles.b3d66e53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hw-red-circles.png
// module id = 414
// module chunks = 33